import type { SVGProps } from "react";
const SvgLuggage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={72}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#luggage_svg__a)" opacity={0.5}>
      <ellipse cx={35.991} cy={66.086} fill="#000" rx={17.6} ry={0.694} />
    </g>
    <path
      fill="url(#luggage_svg__b)"
      d="M24.749 66.088a2.813 2.813 0 1 0 0-5.625 2.813 2.813 0 0 0 0 5.625"
    />
    <path
      fill="url(#luggage_svg__c)"
      d="M47.248 66.088a2.813 2.813 0 1 0 0-5.625 2.813 2.813 0 0 0 0 5.625"
    />
    <path
      fill="url(#luggage_svg__d)"
      d="M47.248 60.463a2.81 2.81 0 0 1 2.813 2.812h-5.626a2.81 2.81 0 0 1 2.813-2.812"
    />
    <path
      fill="url(#luggage_svg__e)"
      d="M24.749 60.463a2.81 2.81 0 0 1 2.813 2.812h-5.626a2.81 2.81 0 0 1 2.813-2.812"
    />
    <path
      fill="url(#luggage_svg__f)"
      d="M40.221 8.03h-8.437v19.615a1.406 1.406 0 1 1-2.811 0V8.03c0-1.642 1.259-2.973 2.81-2.974h8.438c1.553 0 2.813 1.332 2.814 2.974v19.614a1.407 1.407 0 0 1-2.814 0z"
    />
    <foreignObject width={34.625} height={39.931} x={18.682} y={24.061}>
      <div
        style={{
          backdropFilter: "blur(.5px)",
          clipPath: "url(#luggage_svg__g)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <path
      fill="url(#luggage_svg__h)"
      d="M48.088 25.061H23.9a4.22 4.22 0 0 0-4.218 4.219v29.493a4.22 4.22 0 0 0 4.218 4.219h24.188a4.22 4.22 0 0 0 4.219-4.219V29.28a4.22 4.22 0 0 0-4.22-4.219Z"
      data-figma-bg-blur-radius={1}
    />
    <path
      fill="#FF4524"
      d="M31.43 31.937a.703.703 0 0 0-.703.703v25.016a.703.703 0 0 0 1.407 0V32.64a.703.703 0 0 0-.703-.703Zm4.576 0a.703.703 0 0 0-.703.703v25.016a.703.703 0 0 0 1.406 0V32.64a.703.703 0 0 0-.703-.703m4.566 0a.703.703 0 0 0-.703.703v25.016a.703.703 0 0 0 1.406 0V32.64a.703.703 0 0 0-.703-.703"
      opacity={0.3}
    />
    <path
      fill="url(#luggage_svg__i)"
      d="M36.386 42.725s-.384-1.153-.784-1.514L33.9 36.684l1.729-.65s.4-.368.742-.484.706-.061.706-.061l2.82-1.062.666-.455.682-.053 1.739-.882.244.056c.133.422.676 1.983.676 1.983l1.644 4.369-1.13.618-.59.337-.844.204-1.697.726s-.35-.098-.725.058c-.376.156-.705.48-.705.48l-2.802 1.055a5 5 0 0 0-.668-.198Z"
    />
    <path
      fill="#275BFF"
      d="M43.023 7.867H28.961a2.81 2.81 0 0 1 2.812-2.812h8.438a2.81 2.81 0 0 1 2.812 2.812"
      opacity={0.4}
    />
    <defs>
      <linearGradient
        id="luggage_svg__d"
        x1={47.248}
        x2={47.248}
        y1={61.883}
        y2={63.077}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="luggage_svg__e"
        x1={24.749}
        x2={24.749}
        y1={61.883}
        y2={63.077}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="luggage_svg__f"
        x1={24.479}
        x2={38.541}
        y1={17.053}
        y2={17.053}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DCA6FF" stopOpacity={0.9} />
        <stop offset={1} stopColor="#DAA6FF" stopOpacity={0.9} />
      </linearGradient>
      <linearGradient
        id="luggage_svg__h"
        x1={35.994}
        x2={35.994}
        y1={25.062}
        y2={64.206}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCDB1F" stopOpacity={0.5} />
        <stop offset={1} stopColor="#FE9012" />
      </linearGradient>
      <linearGradient
        id="luggage_svg__i"
        x1={33.899}
        x2={47.188}
        y1={37.834}
        y2={37.834}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.102} stopColor="#fff" />
        <stop offset={0.115} stopColor="#E3E3E3" />
        <stop offset={0.204} stopColor="#fff" />
        <stop offset={0.214} stopColor="#E3E3E3" />
        <stop offset={0.233} stopColor="#E3E3E3" />
        <stop offset={0.446} stopColor="#fff" stopOpacity={0.973} />
        <stop offset={0.455} stopColor="#E3E3E3" />
        <stop offset={0.549} stopColor="#fff" />
        <stop offset={0.56} stopColor="#E3E3E3" />
        <stop offset={1} stopColor="#E3E3E3" />
      </linearGradient>
      <radialGradient
        id="luggage_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(24.749 63.275)scale(2.8125)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#1F1F1F" />
        <stop offset={0.462} stopColor="#4D4D4D" />
        <stop offset={0.759} stopColor="#4D4D4D" />
        <stop offset={0.829} stopColor="#3B3B3B" />
        <stop offset={1} stopColor="#141414" />
      </radialGradient>
      <radialGradient
        id="luggage_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(47.248 63.275)scale(2.8125)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#1F1F1F" />
        <stop offset={0.462} stopColor="#4D4D4D" />
        <stop offset={0.759} stopColor="#4D4D4D" />
        <stop offset={0.829} stopColor="#3B3B3B" />
        <stop offset={1} stopColor="#141414" />
      </radialGradient>
      <clipPath id="luggage_svg__g" transform="translate(-18.682 -24.061)">
        <path d="M48.088 25.061H23.9a4.22 4.22 0 0 0-4.218 4.219v29.493a4.22 4.22 0 0 0 4.218 4.219h24.188a4.22 4.22 0 0 0 4.219-4.219V29.28a4.22 4.22 0 0 0-4.22-4.219Z" />
      </clipPath>
      <filter
        id="luggage_svg__a"
        width={39.2}
        height={5.388}
        x={16.391}
        y={63.392}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_3489_107603"
          stdDeviation={1}
        />
      </filter>
    </defs>
  </svg>
);
export default SvgLuggage;
